export default {
	quiz: state => state.quiz,
	defaultAnswer(state){
		state.quiz.questions.map(
			(x) => state.answer.push({id: x.id, data: null})
		);
		return state.answer;
	},
	numQuestionFinish: state => state.finish,
	getAnswer: state => state.answer,
};
